/**
 * Utilities.js
 */

import $ from 'jquery';

export default class Utilities {

  static getImageHeight(imgSrc) {

    return new Promise((resolve) => {
      let newImage = new Image();
      newImage.onload = () => resolve(newImage.height);
      newImage.src = imgSrc;
    });

  }


  // 
  // static addClass(element, className) {
  // 
  //     if (element.classList) {
  //         element.classList = element.classList.push(className);
  //     } else if (element.className) {
  //         element.className = element.className + " className";
  //     }
  // 
  //     return this;
  // }
  // 
  // static removeClass(element, className) {
  // 
  //     if (element.classList) {
  //         var classList = Array.prototype.slice(element.classList);
  //         if (classList.indexOf(className) !== -1) {
  //             classList.slice(classList.indexOf(className));
  //         } else if (element.className) {
  //             // @todo
  //             element.className.replace(className, '');
  //         }
  //     }
  // 
  // }

}